export default {
  EAT_COINS: 'oc coins',
  EAT_CELL: 'fish and pearl'
}
